
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindTrue13 as ObiWindTrue13Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-true-13.js';
 
 
 

 
 export const ObiWindTrue13 = createComponent({
   react: React,
   tagName: 'obi-wind-true-13',
   elementClass: ObiWindTrue13Element,
   events: {
     
   }
  });
 
 